import services from '../../services';
import ConfirmDialog from '../common/ConfirmDialog.vue';
import { useUserStore } from '../../store';


import { computed, ref, onMounted, unref } from 'vue';
// 退出登录跳转链接

export default {
  __name: 'LoggedCom',
  props: {
    nickname: {
      type: String,
      default: ''
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const logoutUrl = computed(() => `https://dict.youdao.com/login/acc/se/reset?product=DICT&samesite=true&ru=${encodeURIComponent(window.location.href)}`);
    const showOptions = ref(false);
    const showQuit = ref(false);
    const useStore = useUserStore();

    // 是否是AIPPT会员
    const isSlideVip = ref(false);
    // 获取AIPPT会员信息
    const getSlideVipInfo = () => {
      services.getSlideVipInfo().then(res => {
        if (res.code === 0) {
          isSlideVip.value = res.data.aipptVip;
          useStore.changeSlideVip(res.data.aipptVip);
        }
      });
    };
    // 是否超级会员
    const isSvip = ref(false);
    // 是否词典会员
    const isVip = ref(false);
    // 获取会员状态信息
    const getVipInfo = () => {
      services.getVipInfo().then(res => {
        isSvip.value = res.svip;
        isVip.value = res.vip;
        useStore.changeSvip(res.svip);
        useStore.changeVip(res.vip);
        // 不是超级会员请求aippt接口，判断是否是ppt会员
        if (!res.svip) {
          getSlideVipInfo();
        }
      });
    };
    onMounted(() => {
      getVipInfo();
    });
    const logout = () => {
      window.location.href = unref(logoutUrl);
      useStore.changeOutlineSyncStatus(false);
      useStore.changeSlideSyncStatus(false);
    };
    const props = __props;
    const __returned__ = {
      logoutUrl,
      showOptions,
      showQuit,
      useStore,
      isSlideVip,
      getSlideVipInfo,
      isSvip,
      isVip,
      getVipInfo,
      logout,
      props,
      get services() {
        return services;
      },
      ConfirmDialog,
      get useUserStore() {
        return useUserStore;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};